<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getForecast">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm-3">
                    <label for="number" class="text-xxs font-weight-normal text-secondary">Forecast Number</label>
                    <input v-model="search.forecast_number" type="text" class="form-control form-control-sm">
                  </div>
                  <div class="col-12 col-sm-3">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Month</label>
                    <Datepicker 
                      v-model="search.month" 
                      range
                      monthPicker
                      format="MMMM yyyy"
                      placeholder="Select month"
                      />
                  </div>
                  <div class="col-12 col-sm-2 align-self-top pt-4 d-flex">
                    <button type="submit" class="btn btn-primary mb-0 justify-content-center" style="width: 50px;" @click="resetOffset">
                      <i class="fa fa-search"></i>
                    </button>

                    <!-- Adding margin to create space -->
                    <button class="btn btn-primary mb-0 justify-content-center" style="width: 50px; margin-left: 5px;" @click="clearSearch">
                      <i class="fa fa-times-circle"></i>
                    </button>

                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-between">
                <div class="d-grip gap-2 d-flex">
                    <!-- <button class="btn btn-xs btn-outline-primary"><i class="fa fa-download"></i> Monthly</button>
                    <button class="btn btn-xs btn-outline-primary"><i class="fa fa-download"></i> Daily</button> -->
                </div>
                <div class="d-flex">
                  <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                  <argon-pagination color="gradient-primary" size="sm">
                    <argon-pagination-item
                    @click="prevPage"
                      prev
                      :disabled="offset === 0 ? true : false" />
                    <argon-pagination-item
                      @click="nextPage"
                      next
                      :disabled="record_more === false ? true : false" />
                  </argon-pagination>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                    <thead>
                        <tr class="bg-light">
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Number</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">PO Period</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Forecast</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Revision</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Status</th>
                        </tr>
                    </thead>
                  <tbody>
                    <tr v-for="(line, i) in forecast" :key="i">
                      <td>
                        <router-link :to="'/forecast-monthly/' + line.id" class="text-xs text-primary font-weight-bold mb-0">
                            {{ line.name }}
                        </router-link>
                      </td>
                      <td>
                        <p class="mb-0 text-xs">{{ line.po_month }} {{ line.po_year }}</p>
                      </td>
                      <td>
                          <p class="mb-0 text-xs">
                            {{ line.forecast_start_month }} {{ line.forecast_start_year }} - {{ line.forecast_end_month }} {{ line.forecast_end_year }}
                          </p>
                      </td>
                      <td>
                          <p class="mb-0 text-xs">{{ line.revision }}</p>
                      </td>
                      <td>
                          <argon-badge color="info" size="sm">{{ line.state }}</argon-badge>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!forecast.length > 0 && !loading"/>
              <loading-state v-if="loading"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "forecast-monthly",
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    ArgonBadge,
    EmptyState,
    LoadingState
  },
  data() {
    return {
      search: {
        forecast_number: null,
        month: null
      },
      loading: false,
      total_data: 0,
      current_total_data: 0,
      current_page: 0,
      offset: 0,
      forecast: []
    };
  },
  methods: {
    prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getForecast()
        }
    },
    nextPage() {
      if (this.record_more === true) {
        this.offset = this.offset + 10
        this.getForecast()
      }
    },
    getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date !== null) {
              let month = date.month >= 9 ? (date.month + 1) : '0' + (date.month + 1)
              let fullDate = date.year + '-' + month + '-' + '01'
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
    getForecast() {
      this.forecast = []
      this.loading = true
      this.total_data = 0
      this.current_total_data = 0
      this.record_more = false
      this.current_page = 0
      const getMonthrange = this.getDate(this.search.month)
      this.axios
        .post(
          endpoint.FORECAST_LIST,
          {
            forecast_number: this.search.forecast_number,
            partner_id: localStorage.getItem('partner_id'),
            start_month: getMonthrange.length > 0 ? getMonthrange[0] : null,
            end_month: getMonthrange.length > 1 ? getMonthrange[1] : null,
            limit: 10,
            offset: this.offset,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.forecast = response.data.data;
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
          } else if (response.data.reponse_code === "4000") {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
          this.loading = false;
        });
    },
    clearSearch(){
          this.search.forecast_number = null;
          this.search.month = null;
    }
  },
  mounted() {
    this.getForecast()
  }
};
</script>

<style>

</style>